export default "__VITE_ASSET__ClVpLYM5__"